<template>
    <div>
        <banner :banner="banner"></banner>
        <div class="cates">
            <div class="catesCon">
                <div class="cateItem flx alc">
                    <div class="cateName">选择类别</div>
                    <div class="cateCon flx">
                        <div @click="scanThis(0,0)" :class="cateId == 0?'cactive' : ''" class="caItem cursor">
                            全部
                        </div>
                        <div @click="scanThis(i,v.id)" :class="cateId == v.id?'cactive' : ''" class="caItem cursor" v-for="v,i in cates" v-text="v.name"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="coaches flx">
            <div class="coachItem" :class="(index + 1) % 4 == 0?'mar0' :'mar28'" v-for="item,index in list" @click="toDetail(item)">
               <div class="coachImg">
                   <img :src="$img(item.pc_avatar)" alt="" />
                   <div class="tag" v-text="item.tag"></div>
               </div>
               <div class="coachInfo">
                   <div class="coachName single" v-text="item.name"></div>
                   <div class="labels flx alc">
                       <div class="label" v-for="item,index in item.label" v-text="item.name"></div>
                   </div>
                   <div class="coachDes multy2" v-text="item.intro"></div>
                   <div class="coachPrice flx jsb">
                       <div class="flx alc">
                           <div class="priceName">
                               报名费
                           </div>
                           <div class="priceNum" v-if="item.default_price * 1 > 0" v-text="`${item.default_price}元`">
                               
                           </div>
                           <div class="priceNum" v-else>
                               免费报名
                           </div>
                       </div>
                       <div class="checknow cursor">
                           马上查看
                       </div>
                   </div>
               </div>
            </div>
            
        </div>
    </div>
</template>

<script>
    import {
       getcerCate,
       getcerList
    } from "@/api/index.js"
    import banner from "@/components/banner.vue"
    export default {
        name: "index",
        components: {
            banner
        },
        data() {
            return {
               banner:[],
               cates:[],
               cateId:'0',
               list:[],
               allbanner:[]
            };
        },
        created() {
            this.getBanner()
        },
        methods: {
            toDetail(d){
                let that = this
                this.$router.push({
                    path: '/cerDetail', // 写路由path
                    query: {
                        id:d.id
                    }
                })
            },
            getBanner(){
                let that = this 
                getcerCate().then((res) => {
                    console.log('cate',res)
                    if(res.code == 1){
                        that.banner = res.data.index_banner
                        that.cates = res.data.category
                        that.allbanner = res.data.index_banner
                        that.getList()
                    }
                    
                })
            },
            getList(){
                let that = this 
                let data = {}
                data.category_id = that.cateId
                data.page = that.page
                data.size = 30
                getcerList(data).then((res) => {
                    console.log(res)
                    if(res.code == 1){
                        that.list = res.data.data
                    }
                    that.$nextTick(() => {
                        window.scrollTo(0, 0)
                    })
                })
            },
            scanThis(index,id){
                let that = this 
                console.log(id)
                if(id == 0){
                    that.page = 1
                    // that.banner = that.allbanner
                    that.cateId = id
                    that.getList()
                }else{
                    that.page = 1
                    that.cateId = id
                    // that.banner = that.cates[index].banner
                    that.getList()
                }
                
            }
        }
    };
</script>

<style scoped>
    .mar0{
        margin-right: 0;
    }
    .mar28{
        margin-right: 28px;
    }
    .checknow{
        width: 104px;
        height: 36px;
        background: linear-gradient( 90deg, #4A9EFF 0%, #1E7FE5 100%);
        box-shadow: 0px 2px 6px 0px rgba(30,127,229,0.25);
        border-radius: 18px;
        text-align: center;
        line-height: 36px;
        font-size: 14px;
        color: #FFFFFF;
    }
    .priceNum{
        color: #EF4444;
        font-size: 16px;
        margin-left: 8px;
        font-weight: bold;
    }
    .priceName{
        font-weight: bold;
        color: #000;
        font-size: 16px;
    }
    .coachDes{
        font-weight: 500;
        margin-bottom: 15px;
        font-size: 14px;
        color: #9CA3AF;
        line-height: 24px;
        text-align: left;
        margin-top: 8px;
        height: 48px;
    }
    .label{
        height: 19px;
        box-sizing: border-box;
        padding: 0 5px;
        font-size: 12px;
        color: #007AFF;
        background: #F4F9FF;
        border-radius: 1px 1px 1px 1px;
        line-height: 19px;
        margin-right: 8px;
    }
    .coachName{
        font-weight: 600;
        font-size: 16px;
        color: #000000;
        text-align: left;
        margin-bottom: 8px;
    }
    .coachInfo{
        box-sizing: border-box;
        padding: 20px;
    }
    .coachImg{
        width: 344px;
        height: 194px;
        position: relative;
        overflow-y: hidden;
    }
    .tag{
        background: linear-gradient( 79deg, #F59E0B 0%, #F4870A 100%);
        box-shadow: 0px 2px 8px 0px rgba(255,71,87,0.35);
        height: 30px;
        line-height: 30px;
        border-radius: 15px 15px 15px 2px;
        font-weight: 600;
        font-size: 13px;
        color: #FFFFFF;
        text-align: center;
        box-sizing: border-box;
        padding: 0 11px;
        position: absolute;
        top: 12px;
        left: 12px;
    }
    .coachImg img{
        width: 100%;
        /* height: 100%; */
        
    }
    .coachItem{
        width: 344px;
        height: 392px;
        background: #fff;
        flex-shrink: 0;
        border-radius: 12px;
        margin-bottom: 20px;
        overflow: hidden;
    }
    .coaches{
        width: 1460px;
        margin: 0 auto;
        flex-wrap: wrap;
        box-sizing: border-box;
        padding: 20px 0;
    }
    .cactive{
        font-weight: 500 !important;
        color: #007AFF !important;
    }
    .caItem{
        margin-right: 40px;
        font-size: 14px;
        color: #4E5366;
        margin-bottom: 0 !important;
    }
    .cateCon{
        flex: 1;
        flex-wrap: wrap;
    }
    .cateName{
        font-weight: 600;
        font-size: 14px;
        color: #222222;
        margin-right: 40px;
    }
    .catesCon{
        width: 1460px;
        margin: 0 auto;
        
    }
    .cateItem{
        padding: 10px 0;
    }
    .cates{
        width: 100%;
        background: #fff;
        box-sizing: border-box;
        padding: 12px 0;
    }
</style>